(() => {
  const root = document.querySelector('[data-ale-journal-article]');
  if (!root) return;

  const body = root.querySelector('[data-journal-article-body]');
  if (!body) return;

  const normalizeText = (text) =>
    (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[:.!]+$/, '')
      .toLowerCase();

  /*
    Permanent Shopify Admin authoring convention:

    FOR YOUR JOURNAL
    Optional H3/H4 title
    Optional one-paragraph introduction
    Bulleted OR numbered list

    The list closes the component. We intentionally do not guess based on
    paragraph length, keywords, or surrounding prose.
  */
  const enhanceJournalBoxes = () => {
    const labels = [...body.querySelectorAll(':scope > p, :scope > h3, :scope > h4')]
      .filter((el) => normalizeText(el.textContent) === 'for your journal');

    labels.forEach((label) => {
      if (label.closest('.ale-letter-journal-box')) return;

      let cursor = label.nextElementSibling;
      let title = null;
      let lead = null;
      let list = null;

      if (cursor?.matches('h3, h4')) {
        title = cursor;
        cursor = cursor.nextElementSibling;
      }

      if (cursor?.matches('p')) {
        lead = cursor;
        cursor = cursor.nextElementSibling;
      }

      if (cursor?.matches('ul, ol')) list = cursor;
      if (!list) return;

      const section = document.createElement('section');
      section.className = 'ale-letter-journal-box';
      section.setAttribute('data-ale-for-your-journal', '');

      label.classList.add('ale-letter-journal-box__label');
      label.parentNode.insertBefore(section, label);
      section.appendChild(label);

      if (title) {
        title.classList.add('ale-letter-journal-box__title');
        section.appendChild(title);
      }

      if (lead) {
        lead.classList.add('ale-letter-journal-box__lead');
        section.appendChild(lead);
      }

      list.classList.add('ale-letter-journal-box__list');
      if (list.matches('ol')) list.classList.add('ale-letter-journal-box__list--ordered');
      else list.classList.add('ale-letter-journal-box__list--unordered');
      section.appendChild(list);
    });
  };

  /*
    QA FIXTURE ONLY — City Tour specimen.
    This runs only while previewing the existing published City Tour article in
    this unpublished QA theme. It does not alter the Shopify article record.
    Remove this fixture after the component is approved and the article source
    is updated using the permanent authoring convention above.
  */
  const addCityTourQAFixture = () => {
    const cityTourPath = '/blogs/the-letter/how-to-show-guests-around-your-city-like-a-thoughtful-local';
    if (window.location.pathname.replace(/\/$/, '') !== cityTourPath) return;
    if (body.querySelector('[data-ale-qa-fixture="city-tour"]')) return;
    if ([...body.querySelectorAll(':scope > p, :scope > h3, :scope > h4')]
      .some((el) => normalizeText(el.textContent) === 'for your journal')) return;

    const directParagraphs = [...body.querySelectorAll(':scope > p')];
    const findParagraph = (test) => directParagraphs.find((p) => test(normalizeText(p.textContent)));

    const insertFixture = (target, titleText = '') => {
      if (!target?.parentNode) return;
      const label = document.createElement('p');
      label.textContent = 'FOR YOUR JOURNAL';
      label.setAttribute('data-ale-qa-fixture', 'city-tour');
      target.parentNode.insertBefore(label, target);

      if (titleText) {
        const title = document.createElement('h3');
        title.textContent = titleText;
        title.setAttribute('data-ale-qa-fixture', 'city-tour');
        target.parentNode.insertBefore(title, target);
      }
    };

    insertFixture(
      findParagraph((text) => text === 'use your journal to sketch a simple guest profile')
    );

    insertFixture(
      findParagraph((text) => text.startsWith('in your journal or notes app, create a page called')),
      'Build your “My City List”'
    );

    insertFixture(
      findParagraph((text) => text === 'write'),
      'Make a simple hosting page'
    );

    insertFixture(
      findParagraph((text) => text === 'you might even write in your journal afterward'),
      'After the visit'
    );
  };

  addCityTourQAFixture();
  enhanceJournalBoxes();
})();
